import React from 'react';
import { Text, View, StyleSheet } from '@react-pdf/renderer';
import { useTranslation } from 'react-i18next';

const prettyMetric = require('pretty-metric');

const styles = StyleSheet.create({
	headerContainer: {
		marginTop: 36,
	},
	billTo: {
		marginTop: 20,
		paddingBottom: 3,
		fontFamily: 'Helvetica-Oblique',
	},
});

const OrderDetails = ({ invoice }) => {
	const { t } = useTranslation();

	const getTimeslot = (slot) => {
		if (slot == 1) return t('morning79');
		if (slot == 2) return t('afternoon123');
		return t('evening57');
	};

	return (
		<View style={styles.headerContainer}>
			<Text style={styles.billTo}>{t('orderDetails')}:</Text>
			{/* <Text>Total Order Amount: {invoice.totalOrderCost.toFixed(2)}</Text> */}
			<Text>
				{t('pickupAddress')}: {invoice.selectedPickupAddress}
			</Text>
			<Text>
				{t('deliveryAddress')}: {invoice.selectedDeliveryAddress}
			</Text>
			<Text>
				{t('dateOfMove')}: {new Date(invoice.selectedDate).toDateString()}
			</Text>
			<Text>
				{t('timeOfMove')}: {getTimeslot(invoice.selectedTimeslot)}
			</Text>
			<Text>
				{/* Total Distance: {(invoice.totalDistance / 1000).toFixed(2)} */}
				{t('totalDistance')}: {prettyMetric(invoice.totalDistance).humanize()}
			</Text>
			<Text>
				{t('totalVolume')}: {invoice.selectedItemsVolume} m3
			</Text>
		</View>
	);
};

export default OrderDetails;
